module.exports = __webpack_public_path__ + "img/animol_n.74863c63.png";